import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useGeoState, useGeoFetch } from '../../components/GeoProvider'
import ErrorMessage from '../../components/Layout/ErrorMessage'
import Spinner from '../../components/Loader/Spinner'
import EmptyMap from '../../components/Map/emptyMap'
import Timeline from '../../components/Timeline'
import Map from '../../components/Map'
import toolTipFormatter from './toolTipFormatter'
import MapLegend from './cdcMapLegendHorizontal'
import SideTable from './SideTable'
import styles from './MapPage.module.scss'
import ErrorLogs from '../../components/ErrorBoundary/errorlogs'
import { useAuthState } from '../../components/AuthProvider'

const DashboardMap = ({ geo_type, geo_parent, zoomLocation }) => {

  const { user } = useAuthState()
  const chartRef = useRef(null)
  const slotTimeInSeconds = 604800000
  const latestPositionString = ''
  const slotString = 'week'
  const location = useLocation()
  const hash = location.hash
  const [getMapStates, setMapStates] = useState()
  const [getMapZip3, setMapZip3] = useState()
  const [activeZip3, setactiveZip3] = useState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getStateJson, setStateJson] = useState()
  const [getzip3Json, setzip3Json] = useState()
  const [isLoading,setIsLoading] =useState(false)
  // let disease_id=1
  const {
    dataStartDate,
    dataEndDate,
    mapOptions,
    regionSelected,
    setRegionSelected,
    displayDate,
    diseaseSelected,
    setDisplayDate,
    setDiseaseSelected
  } = useGeoState()
  // var geo_parent = 'US'
  setDiseaseSelected(window.localStorage.getItem('disease'))
  if (hash) {
    if (hash.split('-').length > 1) {
      setRegionSelected(hash.split('-')[0].replace('#', ''))
    }
  }
  const { data: statesData, error: MapError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'allergiesMap',
    `STATE/${diseaseSelected}`,
    '',
    {
      'geo_parent' : 'US'
    }
  )

  useEffect(() => {
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        var datacount= Object.keys(statesData.response_data).length-1        
        setDisplayDate(Object.keys(statesData.response_data)[datacount])
        setMapStates(statesData.response_data)
      } else {
        setMapStates(null)
        setErrorCode(statesData.response_code)
        setErrorMessage(statesData.response_message)
        setErrorSubject(statesData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [statesData])

  const { data: zip3Datanew, error: MapZipError1 } = useGeoFetch(
     dataStartDate,
    dataEndDate,
    'allergiesMap',
    `ZIP3/${diseaseSelected}`
  )

  useEffect(() => {
    setIsLoading(true)
    if (zip3Datanew !== null && zip3Datanew !== undefined) {
      if (zip3Datanew.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        setMapZip3(zip3Datanew.response_data)
      } else {
        setMapZip3(null)
        setErrorCode(zip3Datanew.response_code)
        setErrorMessage(zip3Datanew.response_message)
        setErrorSubject(zip3Datanew.response_subject)
        seterrorOccured(true)
      }
      setIsLoading(false)
    }
  }, [zip3Datanew])


  const { data: activeZIP3Data, error: activeZIP3DataError } = useGeoFetch(
    dataStartDate,
    dataEndDate,
    'activelocations',
    '',
    '',
    {
      'geo_type' : 'ZIP3'
    }
  )

  useEffect(() => {
    if (activeZIP3Data !== null && activeZIP3Data !== undefined) {
      setactiveZip3(activeZIP3Data)
    }
  }, [activeZIP3Data])


  useEffect(() => {
    let url = `${window.location.origin}/allergies/usStatesAll.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setStateJson(data)
      })
      .catch(function (err) {
        console.log(err, ' error file usStatesAll.json')
      })
  }, [1])


  
  useEffect(() => {
    let url = `${window.location.origin}/allergies/three_dig_zips.json`
    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        setzip3Json(data);
      })
      .catch(function (err) {
        console.log(err, " error file load us_hrr_values ");
      });
  }, [1]);
  if ( MapError || MapZipError1 || activeZIP3DataError || errorOccured ) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }

  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.cbsasPanel}`}>
        <>
          <SideTable geo_id={geo_parent}
          geo_type={geo_type}
          disease_id={diseaseSelected}  />
        </>
      </div>
      <div className={`${styles.timelinePanel}`}>
        {regionSelected === 'state' && (
          <>
            {getMapStates !== undefined && getStateJson ? (
              <>
                <div className={`${styles.providerHeader}`}>
                  <Timeline
                    statesData={getMapStates}
                    latestPositionString={latestPositionString}
                    slotString={slotString}
                    slotTimeInSeconds={slotTimeInSeconds}
                    markCounts={7}
                    loadError={MapError}
                    dashboardType={'ALLERGIES'}
                  />
                </div>
              </>
            ) : (
              <Spinner  />
            )}
          </>
        )}
       
        {regionSelected === 'zip3' && (
          <>
            {getMapZip3 !== undefined && getzip3Json && activeZip3 && getMapStates &&!isLoading
             ? (
              <>
                <div className={`${styles.providerHeader}`}>
                  
                  <Timeline
                    statesData={getMapZip3}
                    latestPositionString={latestPositionString}
                    slotString={slotString}
                    slotTimeInSeconds={slotTimeInSeconds}
                    markCounts={7}
                    loadError={MapError}
                    dashboardType={'ALLERGIES'}
                  />
                </div>
              </>
            ) : (
              <Spinner />
            )}
          </>
        )}
      </div>

      <div className={`${styles.map}`}>
        {regionSelected === 'state' && (
          <>
            {getMapStates !== undefined && getStateJson ? (
              <>
                <div className={styles.legendDiv}>
                <MapLegend />
                </div>
                <Map
                  toolTipFormatter={toolTipFormatter}
                  activeCbsasData={null}
                  statesData={getMapStates}
                  cbsaData={null}
                  mapOptions={mapOptions}
                  dynamicMapTitle={true}
                  mapType="RSVMAP"
                  enableButtons={true}
                  chartRef={chartRef}
                  mapDataType={0}
                  stateJson={getStateJson}
                  dashboardType="ALLERGIES"
                  zip3Data={null}
                />
            
              </>
            ) : (
              <EmptyMap stateJson={getStateJson} />
            )}
          </>
        )}
        {regionSelected === 'zip3' && (
          <>
            {getMapZip3 !== undefined && getzip3Json && activeZip3 && getMapStates &&!isLoading
             ? (
              <>
               <div className={styles.legendDiv}>
                <MapLegend />
                </div>
                <Map
                  toolTipFormatter={toolTipFormatter}
                  activeCbsasData={null}
                  activeZip3Data={activeZip3}
                  statesData={getMapStates}
                  cbsaData={null}
                  mapOptions={mapOptions}
                  dynamicMapTitle={true}
                  mapType="ZIP3MAP"
                  enableButtons={true}
                  chartRef={chartRef}
                  mapDataType={0}
                  stateJson={getStateJson}
                  dashboardType="ALLERGIES"
                  zip3Json={getzip3Json}
                  zip3Data={getMapZip3}
                />


              </>
            ) : (
              <EmptyMap stateJson={getStateJson} />
            )}
          </>
        )}
      </div>
      
      
    </div>
  )
}

export default DashboardMap
